import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { NavigationMenuContent } from "@/components/ui/navigation-menu";
import { Story } from '@/utils/storiesData';
import { storyCategories } from '@/data/storyCategories';
import EditorsPicksSection from './EditorsPicksSection';
interface StoriesMenuProps {
  menuBg: string;
  menuHeaderText: string;
  menuItemText: string;
  menuText: string;
  hoverBg: string;
  borderColor: string;
  stories: Story[];
  isLoading: boolean;
}
const StoriesMenu: React.FC<StoriesMenuProps> = ({
  menuBg,
  menuHeaderText,
  menuItemText,
  menuText,
  hoverBg,
  borderColor,
  stories,
  isLoading
}) => {
  const navigate = useNavigate();
  return <NavigationMenuContent className={`w-screen left-0 right-0 ${menuBg} shadow-[0_8px_16px_-4px_rgba(0,0,0,0.1)] border-b border-gray-200/10`}>
      <div className="container mx-auto p-4">
        <div className="grid grid-cols-[240px_1fr_1fr] gap-6">
          <div className="border-r border-opacity-10">
            <h3 className={`text-sm font-medium uppercase tracking-wider mb-2 ${menuHeaderText} font-chroma`}>
              READ MORE
            </h3>
            <div className="space-y-1.5">
              {storyCategories.map(category => <button key={category.slug} onClick={() => navigate(`/browse?category=${encodeURIComponent(category.title)}`)} className={`group w-full text-left hover:${hoverBg} rounded-sm px-2 py-1 transition-colors`}>
                  <span className={`text-sm font-medium ${menuItemText}`}>
                    {category.title}
                  </span>
                </button>)}
            </div>
          </div>

          <div className="space-y-6">
            <h3 className={`text-sm font-medium uppercase tracking-wider mb-3 ${menuHeaderText} font-chroma`}>
              LATEST ARTICLES
            </h3>
            <div className="space-y-4">
              {stories.slice(0, 3).map(story => <button key={story.id} onClick={() => navigate(`/stories/${story.slug}`)} className="group w-full text-left rounded-sm p-2 transition-colors flex gap-4 px-[4px]">
                  <div className="w-16 h-16 flex-shrink-0 overflow-hidden mr-4">
                    <img src={story.coverImage} alt={story.title} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="flex-1">
                    <h4 className={`text-sm font-medium group-hover:underline line-clamp-2 ${menuItemText}`}>
                      {story.title}
                    </h4>
                    <p className={`text-sm mt-1 line-clamp-2 ${menuText}`}>
                      {story.excerpt}
                    </p>
                  </div>
                </button>)}
            </div>
            <button onClick={() => navigate('/browse')} className={`flex items-center gap-2 text-sm ${menuItemText} hover:underline`}>
              ALL LATEST <ArrowRight size={14} />
            </button>
          </div>

          <EditorsPicksSection stories={stories} menuItemText={menuItemText} menuText={menuText} menuHeaderText={menuHeaderText} borderColor={borderColor} />
        </div>
      </div>
    </NavigationMenuContent>;
};
export default StoriesMenu;